/* eslint-disable no-underscore-dangle */
import styled from '@emotion/styled';
import { injectGlobal } from '@emotion/css';
import { css, keyframes } from '@emotion/react';
import { COMPONENT_SPACING } from './spacing';
import {
  PAGE_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_HOVER_COLOR,
  _ab_color as _AB_COLOR,
  ecommerceColors,
} from './colors';
import { min1440, min768, max768, max425, max375 } from './mediaQuery';

// Fade transition
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const _FadeTransition = styled.div`
  animation: ${fadeIn} 1s linear;
  transition: opacity 800ms ease-in;
`;

injectGlobal`
  ._container-fluid {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .largeFontAwesome {
    width: 78px;
    color: yellow;
  }
  .mediumFontAwesome {
    width:52px;
    color: red;
  }
  .smallFontAwesome {
    width:26px;
    color: green;
  }
  .inputLabelMedium {
    font-size: 1.1em;
    font-weight: normal;
  }
  .sa-confirm-button-container {
    display: inline-block;
  }
`;

export const _ab_color = _AB_COLOR;

export const _ab_marginPadding = {
  // paddings and margins
  mediumIconPadding: '5px',
  iconMarginLeft: '5px',
  iconMarginRight: '5px',
};

export const _ab_size = {
  inputLabelMediumSize: '1.1em',
  inputFontWeight: '700',
  smallIconSize: '25px', //not in use yet.
  mediumIconSize: '36px', //close button on cards
  hugeIconSize: '110px', // vcard symbol in profile page.

  smallInputWidth: '200px',
  mediumInputWidth: '300px',
  largeInputWidth: '600px',
};

export const _ab_fontsize = {
  title: '1.2em',
  finePrint: '0.9em',
};

export const _ab = {
  ..._ab_color,
  ..._ab_marginPadding,
  ..._ab_size,
};

export const getColor = c => {
  switch (c) {
    case 'blue':
      return _ab.blue;
    case 'hoverBlue':
      return _ab.hoverBlue;
    case 'red':
      return _ab.red;
    case 'hoverRed':
      return _ab.hoverRed;
    case 'borderRed':
      return _ab.borderRed;
    case 'boxShadowRed':
      return _ab.boxShadowRed;
    case 'green':
      return _ab.green;
    case 'hoverGreen':
      return _ab.hoverGreen;
    case 'grey':
      return _ab.grey;
    case 'hoverGrey':
      return _ab.hoverGrey;
    case 'mediumGrey':
      return _ab.mediumGrey;
    case 'warningYellow':
      return _ab.yellow;
    case 'darkBlue':
      return _ab.darkBlue;
    case 'hoverDarkBlue':
      return _ab.hoverDarkBlue;
    case 'turquoise':
      return ecommerceColors.turquoise;
    case 'transparent':
      return 'none';
  }

  if (_ab.hasOwnProperty(c)) return _ab[c]; // eslint-disable-line no-prototype-builtins
};

export const _ContentWrapper = styled('div')`
  background: ${_ab.backgroundGrey};
`;

export const _RowInputContainer = styled('div')`
  width: 100%;
  padding: 10px 0px 10px 0px;
`;

export const _ProvideLaterMessage = styled('p')`
  padding-left: 30px;
  word-break: break-word;
`;

export const _TwoColInputContainer = styled('div')`
  display: inline-block;
  padding: 0px 15px 0px 15px;
  text-align: left;
  ${min768} {
    max-width: 66%;
    width: 66%;
  }
  ${max768} {
    max-width: 100%;
    width: 100%;
  }
`;

export const _InputContainer = styled<{ widthOnLargeScreens?: '1/6' }>('div')`
  display: inline-block;
  padding: 5px 15px 5px 15px;
  text-align: left;
  ${min768} {
    max-width: 33%;
    width: 33%;
  }
  ${max768} {
    max-width: 50%;
    width: 50%;
  }
  ${max425} {
    max-width: 100%;
    width: 100%;
  }
  ${props =>
    props.widthOnLargeScreens === '1/6'
      ? `
    ${min1440} {
      max-width: 16.5%;
      width: 16.5%;
    }
  `
      : ''}
`;

export const _InputContainerEnd = styled(_InputContainer)`
  display: flex;
  align-items: flex-end;
`;

export const _TestScoresInputContainer = styled('div')`
  display: inline-block;
  padding: 5px 15px 5px 15px;
  text-align: left;
  ${min768} {
    max-width: 20%;
    width: 20%;
  }
  ${max768} {
    max-width: 50%;
    width: 50%;
  }
  ${max425} {
    max-width: 100%;
    width: 100%;
  }
`;

export const _EnglishExamTypeInputWrapper = styled('div')`
  display: inline-block;
  padding: 5px 15px 5px 15px;
  text-align: left;
  ${min768} {
    max-width: 17%;
    width: 17%;
  }
  ${max768} {
    max-width: 100%;
    width: 100%;
  }
  ${max425} {
    max-width: 100%;
    width: 100%;
  }
`;

/* StickMe.jsx */
export const _ProgressBarStickyWrapper = styled('div')`
  background: rgba(255, 255, 255, 0.8);
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  height: 130px;
  padding: 5px 15px 5px 15px;
  z-index: 100;
  ${max768} {
    height: 150px;
  }
  ${max425} {
    height: 80px;
  }
  ${max375} {
    height: 75px;
  }
`;

export const _NavigationBarStickyWrapper = styled('div')`
  background: rgba(255, 255, 255, 0.8);
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  height: 60px;
  padding: 5px 15px 5px 15px;
  z-index: 1;
  ${max375} {
    height: 50px;
  }
`;

export const _RegistrationDateWrapper = styled('div')`
  font-size: 1.2em;
  font-weight: bold;
  padding-left: 35px;
`;

const _requiredCSS = props => css`
  ${propsToStyles(props)}
`;

function propsToStyles(props) {
  let obj = '';
  for (const name in props) {
    obj += `${name}: ${props[name]};`;
  }
  return obj;
}

const createStyled = (type, str?: string) => styled(type)`
  ${_requiredCSS};
  ${str}
`;

export const _CustomStyledDiv = createStyled('div');
export const _CustomStyledSpan = createStyled('span');

export const _IconRadioInput = createStyled(
  'span',
  `
  * {
    margin-right: 8px;
    &:last-child {
      margin-right: 0px;
    }
  }
`,
);
_IconRadioInput.displayName = '_IconRadioInput';

export const _IconRadio = createStyled(
  'span',
  `
  opacity: 0.2;
  transition: all 0.2s;
  cursor: pointer;
  &.selected {
    opacity: 1;
  }
`,
);
_IconRadio.displayName = '_IconRadio';

export const _MoreOptions = createStyled(
  'div',
  `
  position: relative;
  .mo-icon {
    font-size: 15px;
    height: 30px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.1s;
    > * {
      opacity: 0.6;
    }
    &:not(.opened):hover {
      background-color: #F5F5F5;
      > * {
        opacity: 1;
      }
    }
    &.opened {
      background-color: #F2F2F2;
      > * {
        opacity: 0.6;
      }
    }
  }
  .mo-options {
    position: absolute;
    right: 0px;
    top: 50%;
    width: 240px;
    pointer-events: none;
    opacity: 0;
    transform-origin: top right;
    transform: rotateX(-35deg) scale(0.7,0.9);
    transition: all 0.15s;
    z-index: 1;
    &.opened {
      pointer-events: all;
      opacity: 1;
      transform: none;
      top: 100%;
    }
    .mo-option {
      background-color: white;
      font-size: 13px;
      padding: 12px 16px;
      border: 1px solid rgba(0, 0, 0, 0.03);
      box-shadow: 0px 5px 6px 0px rgba(0,0,0,0.05);
      cursor: pointer;
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
`,
);
_MoreOptions.displayName = '_MoreOptions';

export const _ProgressBarContainer = createStyled(
  'div',
  `
  display: flex;
  align-items: center;
  .pb-progress {
    font-weight: bold;
    margin-right: 6px;
  }
`,
);
_ProgressBarContainer.displayName = '_ProgressBarContainer';

export const _ProgressBar = createStyled(
  'div',
  `
  width: 100%;
  height: 4px;
  background-color: #F1F1F1;
  border-radius: 10px;
  position: relative;
  .pb-child {
    position: absolute;
    height: 100%;
    top: 0px;
    left: 0px;
    border-radius: 10px;
    background-color: #428BCA;
    transition: all 0.2s;
  }
`,
);
_ProgressBar.displayName = '_ProgressBar';

export const _InlineEditContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
`;

type IInlineEdit = {
  show?: boolean;
  openFrom?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  direction?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
};
export const _InlineEdit = styled.div<IInlineEdit>`
  background-color: white;
  border-radius: 7px;
  border: 1px solid ${_ab_color.lightGrey};
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  opacity: ${props => (props.show ? '1' : '0')};
  pointer-events: ${props => (props.show ? 'all' : 'none')};
  position: absolute;
  transition: all 0.1s ease-out;
  z-index: 1;

  ${props => {
    let originx = '50%';
    let originy = '50%';
    let top = null;
    let bottom = null;
    let left = null;
    let right = null;
    let translatex = '-50%';
    switch (props.openFrom) {
      case 'right':
        originx = '0%';
        left = '22px';
        translatex = '0%';
        break;
      case 'left':
        originx = '100%';
        right = '0px';
        translatex = '0%';
        break;
      default:
        left = '50%';
        break;
    }
    // eslint-disable-next-line default-case
    switch (props.direction) {
      case 'down':
        originy = '0%';
        top = '0px';
        break;
      case 'up':
        originy = '100%';
        bottom = '0px';
        break;
    }
    return `
      ${top ? `top: ${top};` : ''}
      ${left ? `left: ${left};` : ''}
      ${bottom ? `bottom: ${bottom};` : ''}
      ${right ? `right: ${right};` : ''}
      transform-origin: ${originx} ${originy};
      transform: translate(${translatex}) ${props.show ? 'scaleY(1)' : 'scaleY(0.9)'};
    `;
  }}
}`;

type IInlineEditOptionProps = {
  selected?: boolean;
};
export const _InlineEditOption = styled.div<IInlineEditOptionProps>`
  background-color: ${props => (props.selected ? _ab_color.backgroundGrey : null)};
  cursor: ${props => (props.selected ? 'not-allowed' : 'pointer')};
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  &:hover {
    background-color: ${_ab_color.lightGrey};
  }
`;

export const _InlineSelected = styled('div')`
  cursor: pointer;
  border: 1px solid;
  border-color: white;
  transition: all 0.1s ease-out;
  padding: 6px;
  border-radius: 7px;
  &:hover {
    background-color: ${_ab_color.lightGrey};
    border-color: ${_ab_color.lightGrey};
  }
`;

type IDropzoneOverlayType = {
  full?: boolean;
  hovering?: boolean;
  dragging?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
};
export const _DropzoneOverlay = styled.div<IDropzoneOverlayType>`
  width: ${({ full }) => (full ? '100%' : 'calc(100% - 12px)')};
  height: ${({ full }) => (full ? '100%' : 'calc(100% - 12px)')};
  position: absolute;
  left: ${({ full }) => (full ? '0px' : '6px')};
  top: ${({ full }) => (full ? '0px' : '6px')};
  border: 2px dashed ${props => (props.hovering ? _ab_color.blue : _ab_color.lightGrey)};
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${props => (props.dragging ? '1' : '0')};
  pointer-events: ${props => (props.dragging ? 'all' : 'none')};
  transition: all 0.1s;
  > span {
    font-size: 20px;
    color: ${_ab_color.blue};
    display: flex;
    justify-content: center;
    align-items: center;
    > span:last-child {
      font-size: 16px;
      margin-left: 12px;
    }
  }
`;

export const MiniButton = styled.button`
  align-items: center;
  background-color: ${_ab_color.backgroundGrey};
  border-radius: 7px;
  border: 1px solid ${_ab_color.lightGrey};
  cursor: pointer;
  display: inline-flex;
  margin: 4px;
  padding: 4px;

  & span {
    margin: 0;
    font-size: 13px;
  }
  &:active {
    background-color: ${_ab_color.backgroundLightGrey};
  }
`;

export const _SearchInput = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  > *:first-child {
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    z-index: 1;
  }
  input {
    padding-left: 34px;
  }
`;

type IPageProps = {
  disableScroll?: boolean;
};
export const Page = styled.div<IPageProps>`
  -webkit-font-smoothing: antialiased;
  color: ${PAGE_COLOR};
  font-size: 13px;
  height: ${props => (props.disableScroll ? '60vh' : 'auto')};
  overflow: ${props => (props.disableScroll ? 'hidden' : 'initial')};
  padding: ${COMPONENT_SPACING};

  ${min768} {
    height: ${props => (props.disableScroll ? '80vh' : 'auto')};
  }
`;

export const _AttachmentsTitle = styled.div`
  margin-right: 5px;
  > * {
    align-items: center;
    display: flex;
    > *:first-child {
      margin-right: 8px;
    }
  }
`;

export const _Attachment = styled.span`
  background-color: ${_ab_color.backgroundGrey};
  border-radius: 20px;
  margin-left: 10px;
  margin-right: 0px;
  margin-bottom: 5px;
  padding: 2px 10px;
  word-break: break-word;
`;

export const _AttachmentText = styled.span`
  cursor: pointer;
  color: ${PRIMARY_BUTTON_COLOR};
  &:hover {
    color: ${PRIMARY_BUTTON_HOVER_COLOR};
  }
`;

export const _Attachments = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -5px;
  margin-left: -10px;
`;

export const _DeleteAttachment = styled.span`
  cursor: pointer;
  padding-left: 3px;
`;
